module.exports = __webpack_public_path__ + "img/struga-logo-icon.62ec1018.png";